import '@picocss/pico/css/pico.min.css';
import './style.css';

/* import './Skeleton-2.0.4/css/normalize.css';
import './Skeleton-2.0.4/css/skeleton.css'; */
import {mountMithril} from './view.js'; // NO DEBUG THANKS
// import {mountMithril} from './debug/view-with-extra-debug.js'; // YES QUITE DEBUG
mountMithril();